module.exports = "<app-header></app-header>\n<app-content></app-content>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main